module.exports = __webpack_public_path__ + "img/logowhite.f23ff1c4.svg";